// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"935ff53d","531":"935ff53d"}[chunkId] + ".chunk.css";
};